/* FURPPL Her & Her Dog combo menu (2026-10-24): the cards and the filters of sections/furppl-combos.liquid.
   Founder: "It's like buying hamburger combos, make it easy for them." A card holds fixed items; the shopper picks sizes and
   taps "Add combo to bag": ONE /cart/add.js call with every item, plus the bag holder and the matching leash when ticked. No free pieces (founder
   10-25: "no free pieces").
   Deep links (filters at the bottom): ?set=<slug> or #set-<slug> opens on one set (founder 10-25: customers see "sets"
   and no numbers; Marketing's links name the set), and the older ?combo=N or #combo-N still do; ?filter=a,b presets the
   pills, with collar, collar-leash, harness, harness-leash, christmas; the old budget links (under-100, 100-200, over-200)
   set the Price filter instead, since the budget pills went (founder 10-25); ?sort_by= presets the sort box. The filter
   column beside the menu (Price, Category, Color) is the collection pages' own facet markup, filled and run here. */
(function () {
  if (window.customElements.get('furppl-combo')) return;

  function formatter(sample) {
    // The theme's own format of 1,234,567.89 in the shopper's currency gives the prefix, suffix and separators. Set prices
    // follow the store format, whole units (founder 10-25: "round, the cents for all products DO show at check out");
    // a store format with cents keeps them.
    const digits = [...sample].map((c, i) => (/\d/.test(c) ? i : -1)).filter((i) => i >= 0);
    const prefix = sample.slice(0, digits[0]);
    const suffix = sample.slice(digits[digits.length - 1] + 1);
    const num = sample.slice(digits[0], digits[digits.length - 1] + 1);
    const decimal = /[.,]\d{2}$/.test(num) ? num.charAt(num.length - 3) : '';
    const group = ((decimal ? num.slice(0, -3) : num).match(/[^\d]/) || [''])[0];
    return function (cents) {
      const value = decimal ? (cents / 100).toFixed(2) : String(Math.ceil(cents / 100)) /* founder 10-26: whole dollars, rounded UP (never below the charge) */;
      const parts = value.split('.');
      return prefix + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, group) + (parts[1] ? (decimal || '.') + parts[1] : '') + suffix;
    };
  }

  // a few products name an option with a verb ("Select Length"); the card shows the noun
  function optName(name) {
    return String(name).replace(/^(select|seleccionar|selecciona|seleccione)\s+/i, '');
  }

  const ITEMS = ['her', 'dog', 'dog2', 'leash', 'bag', 'set', 'leash_addon'];

  class FurpplCombo extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.t = this.closest('.furppl-combos').dataset;
      this.money = formatter(this.t.money);
      const d = (this.data = JSON.parse(this.querySelector('[data-combo]').textContent));
      ITEMS.forEach((k) => {
        const it = d[k];
        if (!it) return;
        // the build lists a preset's variants in size order (small to large)
        if (it.only && it.only.length) it.v.sort((a, b) => it.only.indexOf(String(a.id)) - it.only.indexOf(String(b.id)));
        it.v.forEach((v) => {
          v.u = it.u;
          v.fs = !!it.fs;
          if (!v.i) v.i = it.i;
        });
      });
      // the dog's item can be two harnesses in ONE size list (e.g. SoHo for small dogs, then NoMad)
      this.parts = {
        her: d.her ? d.her.v : [],
        dog: [].concat(d.dog ? d.dog.v : [], d.dog2 ? d.dog2.v : []),
        leash: d.leash ? d.leash.v : [],
        leash_addon: d.leash_addon ? d.leash_addon.v : [],
        set: d.set ? d.set.v : [],
      };
      this.base = ['her', 'dog'].concat(d.leash ? ['leash'] : []);
      this.harness = /^harness/.test(this.dataset.type || '');
      this.chosen = {};
      this.dead = {};
      this.finalSale = {};
      this.totalEl = this.querySelector('[data-total]');
      this.mealsEl = this.querySelector('[data-meals]');
      this.button = this.querySelector('.furppl-combo__add');
      this.error = this.querySelector('.furppl-combo__error');
      // the paid add-ons, each an unticked box: her matching FURPPL piece ("Complete her set") and the bag holder
      this.addons = ['bag'].map((k) => ({ box: this.querySelector('[data-addon="' + k + '"]'), v: d[k] ? d[k].v.find((v) => v.a) : null }))
        .filter((x) => x.box && x.v);
      const picks = this.querySelector('[data-picks]');
      this.base.forEach((part) => this.picker(part, picks));
      this.addons.forEach((x) => x.box.addEventListener('change', () => this.update()));
      // the picker add-ons, "Complete her look" and the matching leash (leash_addon_1029.py, founder 10-28: "on all the sets we
      // have, we should also mention as an add on (like the poop bags) its respective leash"; picker_addons_1029.py, 10-29: a
      // her piece with lengths): unticked; once ticked each is one more required pick, with its list under the box when the
      // piece has more than one variant (a bracelet's length; Dogistry S to L; 2 Hounds 5/8 or 1 inch wide)
      this.pickers = ['set', 'leash_addon'].map((k) => ({ k: k, box: this.querySelector('[data-addon="' + k + '"]'), picks: this.querySelector('[data-addon-picks="' + k + '"]') }))
        .filter((x) => x.box && x.picks && this.parts[x.k].some((v) => v.a));
      this.pickers.forEach((x) => {
        this.picker(x.k, x.picks);
        x.box.addEventListener('change', () => {
          x.picks.hidden = !x.box.checked || !x.picks.childElementCount;
          this.update();
        });
      });
      this.button.addEventListener('click', () => this.add());
      // founder 10-25: "The Donates 11 meals ... if clicked, add to cart": the meal pill adds the set, as it adds the piece on
      // product pages (layout/theme.liquid finds no quick add on a set card, so it leaves the pill to this)
      this.mealsEl.addEventListener('click', () => this.mealAdd());
      this.mealsEl.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        this.mealAdd();
      });
      this.update();
    }

    // the picks a set needs before it can be added: her piece, the dog's item, an included leash, and the matching leash
    // while its box is ticked
    get required() {
      return this.base.concat((this.pickers || []).filter((x) => x.box.checked).map((x) => x.k));
    }

    // an Outlet item is final sale: the product pages' line (class final-sale-note) under that item, shown while the pick
    // (or, before a pick, every choice) is an Outlet item (the matching leash's line is in the Liquid, like the bag holder's)
    finalSaleNote(part, wrap) {
      if (part === 'leash_addon' || part === 'set' || !this.parts[part].some((v) => v.fs) || !this.t.finalSale) return;
      const p = document.createElement('p');
      p.className = 'final-sale-note';
      // founder 10-26 ("On what? The neckalce or the collar?"): the note names its item, "Final sale (collar): ..."; her piece
      // by the card's own word for it (Necklace + collar -> necklace)
      const sub = ((this.querySelector('.furppl-combo__sub') || {}).textContent || '').split('+')[0].trim();
      const role = part === 'her' ? sub.charAt(0).toLowerCase() + sub.slice(1) : /^leash/.test(part) ? this.t.tLeash : this.harness ? this.t.tHarness : this.t.tCollar;
      const safe = String(role || '').replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]));
      p.innerHTML = safe ? this.t.finalSale.replace(/:\s*<\/strong>/, ' (' + safe + '):</strong>') : this.t.finalSale;
      wrap.append(p);
      this.finalSale[part] = p;
    }

    picker(part, picks) {
      const d = this.data;
      const vs = this.parts[part];
      if (vs.length === 1) {
        this.chosen[part] = vs[0];
        if (vs[0].fs) {
          const wrap = document.createElement('div');
          wrap.className = 'furppl-combo__pick';
          this.finalSaleNote(part, wrap);
          picks.append(wrap);
        }
        return;
      }
      const keys = part === 'dog' ? ['dog', 'dog2'].filter((k) => d[k]) : [part];
      const vary = {};
      const named = {};
      keys.forEach((k) => {
        vary[k] = d[k].o.map((_, i) => new Set(d[k].v.map((v) => v.o[i])).size > 1);
        // an option whose value differs on every variant names each one alone, e.g. the size when a preset ties the
        // width to it (2 Hounds: XSmall is 5/8 inch, every other size 1 inch); a size option wins over the others
        const unique = d[k].o.map((_, i) => i).filter((i) => vary[k][i] && new Set(d[k].v.map((v) => v.o[i])).size === d[k].v.length);
        named[k] = unique.find((i) => /size|talla|tama/i.test(d[k].o[i]));
        if (named[k] === undefined) named[k] = unique[0];
      });
      const role = part === 'her' || part === 'set' ? this.t.tForHer : /^leash/.test(part) ? this.t.tLeash : this.harness ? this.t.tHarness : this.t.tCollar;
      const wrap = document.createElement('div');
      wrap.className = 'furppl-combo__pick';
      if (keys.length > 1 || vary[keys[0]].filter(Boolean).length < 2 || named[keys[0]] !== undefined) {
        // ONE list: each variant by the value that names it, or by the values that differ (a preset fixes the rest);
        // two products = two groups
        let label;
        if (part === 'her' || part === 'set') {
          const names = named[part] !== undefined ? [optName(d[part].o[named[part]])] : d[part].o.filter((_, i) => vary[part][i]).map(optName);
          label = (names.join(' / ') || optName(d[part].o[0])) + ', ' + role;
          // addon_label_1029.py: the her-look add-on's list is named by its piece ("Bracelet length"), never the necklace's label;
          // only when the list chooses by what that label names (the Furiends cuff chooses a colour, not a length)
          const pl = picks.dataset.pickerLabel, about = pl && (/length|largo/i.test(pl) ? /length|largo/i : /style|estilo/i.test(pl) ? /style|estilo/i : null);
          if (part === 'set' && about && about.test(names.join(' '))) label = pl;
        } else {
          label = /^leash/.test(part) ? this.t.tLeashSize : this.harness ? this.t.tHarnessSize : this.t.tCollarSize;
        }
        const select = document.createElement('select');
        select.setAttribute('aria-label', label);
        select.add(new Option(label, ''));
        keys.forEach((k) => {
          const box = keys.length > 1 ? Object.assign(document.createElement('optgroup'), { label: d.g[k] || d[k].t }) : select;
          d[k].v.forEach((v) => {
            const text = named[k] !== undefined ? v.o[named[k]] : v.o.filter((_, i) => vary[k][i]).join(' / ') || v.o.join(' / ');
            const option = new Option(text + (v.a ? '' : ' (' + this.t.tSoldOut + ')'), String(v.id));
            option.disabled = !v.a;
            box.append(option);
          });
          if (box !== select) select.append(box);
        });
        select.addEventListener('change', () => {
          this.chosen[part] = vs.find((v) => String(v.id) === select.value);
          this.update();
        });
        wrap.append(select);
      } else {
        // a list per option (width, size, hardware...), like a product page; a value that cannot make an available
        // variant with the other lists' picks is disabled
        const k = keys[0];
        const idx = d[k].o.map((_, i) => i).filter((i) => vary[k][i]);
        const sels = idx.map((i) => {
          const label = optName(d[k].o[i]) + ', ' + role;
          const select = document.createElement('select');
          select.setAttribute('aria-label', label);
          select.add(new Option(label, ''));
          [...new Set(d[k].v.map((v) => v.o[i]))].forEach((value) => select.add(new Option(value, value)));
          wrap.append(select);
          return select;
        });
        const sync = () => {
          const want = sels.map((s) => s.value);
          sels.forEach((s, j) => {
            [...s.options].forEach((option) => {
              if (!option.value) return;
              option.disabled = !d[k].v.some((v) => v.a && v.o[idx[j]] === option.value && idx.every((i, n) => n === j || !want[n] || v.o[i] === want[n]));
            });
          });
          if (want.some((value) => !value)) {
            this.chosen[part] = undefined;
            this.dead[part] = false;
          } else {
            const v = d[k].v.find((x) => idx.every((i, n) => x.o[i] === want[n]));
            this.chosen[part] = v && v.a ? v : undefined;
            this.dead[part] = !(v && v.a);
          }
        };
        sels.forEach((s) => s.addEventListener('change', () => {
          sync();
          this.update();
        }));
        sync();
      }
      const note = d.note && d.note[part];
      if (note) {
        const p = document.createElement('p');
        p.className = 'furppl-combo__note';
        p.textContent = note;
        wrap.append(p);
      }
      this.finalSaleNote(part, wrap);
      picks.append(wrap);
    }

    update() {
      let total = 0;
      let meals = 0;
      let from = false;
      let ready = true;
      this.required.forEach((part) => {
        const chosen = this.chosen[part];
        const pool = chosen ? [chosen] : this.parts[part].filter((v) => v.a);
        if (!chosen) ready = false;
        if (!pool.length) return;
        const min = Math.min.apply(null, pool.map((v) => v.p));
        const cheapest = pool.find((v) => v.p === min);
        total += min;
        meals += cheapest.m;
        if (!chosen && pool.some((v) => v.p !== min)) from = true;
        // the photo and its link follow the pick (e.g. the NoMad harness once a NoMad size is picked)
        const shown = chosen || cheapest;
        if (this.finalSale[part]) this.finalSale[part].hidden = !(chosen ? chosen.fs : this.parts[part].every((v) => v.fs));
        const a = this.querySelector('.furppl-combo__img[data-slot="' + part + '"]');
        const img = a && a.querySelector('img');
        if (img && shown.i && img.getAttribute('src') !== shown.i) img.src = shown.i;
        if (a && shown.u && a.getAttribute('href') !== shown.u) a.setAttribute('href', shown.u);
      });
      this.addons.forEach((x) => {
        if (!x.box.checked) return;
        total += x.v.p;
        meals += x.v.m;
      });
      (this.pickers || []).forEach((x) => {
        // a picker add-on's price beside its box: the picked variant's, or the lowest ("from" while its variants differ)
        const el = x.box.parentElement.querySelector('[data-addon-price]');
        const c = this.chosen[x.k];
        const pool = this.parts[x.k].filter((v) => v.a);
        const min = Math.min.apply(null, pool.map((v) => v.p));
        if (el) el.textContent = '+' + (!c && pool.some((v) => v.p !== min) ? this.t.tFrom + ' ' : '') + this.money(c ? c.p : min);
      });
      this.totalEl.textContent = (from ? this.t.tFrom + ' ' : '') + this.money(total);
      this.mealsEl.textContent = meals === 1 ? this.t.tMealOne : this.t.tMealMany.replace('7777', String(meals));
      this.mealsEl.setAttribute('aria-label', this.button.textContent.trim() + ': ' + this.mealsEl.textContent);
      this.button.disabled = !ready;
      this.button.setAttribute('aria-disabled', String(!ready));
      const need = this.required;
      this.showError(Object.keys(this.dead).some((k) => this.dead[k] && need.includes(k)) ? this.t.tUnavailable : '');
    }

    // until every size is picked, the pill opens the first choice still to make instead of adding
    mealAdd() {
      if (!this.button.disabled) {
        this.add();
        return;
      }
      const open = [...this.querySelectorAll('[data-picks] select, [data-addon-picks]:not([hidden]) select')].find((s) => !s.value && !s.disabled);
      if (!open) return;
      open.focus();
      try {
        open.showPicker();
      } catch (e) {
        // a browser without showPicker: the focused box is enough
      }
    }

    showError(message) {
      this.error.textContent = message || '';
      this.error.hidden = !message;
    }

    add() {
      if (this.button.disabled) return;
      const lines = this.required.map((part) => this.chosen[part]);
      if (lines.some((v) => !v)) return;
      // every line of a set carries the hidden property _set, its slug, so the cart can tell a set is in it (founder 10-25:
      // "Show us your match" "on every cart with sets"); the theme hides properties that start with _
      const mark = this.dataset.slug ? { _set: this.dataset.slug } : null;
      const line = (id) => (mark ? { id: id, quantity: 1, properties: mark } : { id: id, quantity: 1 });
      const items = lines.map((v) => line(v.id));
      this.addons.forEach((x) => {
        if (x.box.checked) items.push(line(x.v.id));
      });
      const routes = window.routes || {};
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = { items: items };
      if (cart) {
        body.sections = cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
      }
      this.button.classList.add('loading');
      this.button.disabled = true;
      this.showError('');
      if (cart) cart.setActiveElement(this.button);
      fetch((routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.showError(response.description || response.message || this.t.tError);
            return;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'furppl-combos', cartData: response });
          }
          if (!cart) {
            window.location = routes.cart_url || '/cart';
            return;
          }
          if (cart.tagName === 'CART-NOTIFICATION') {
            // The theme's notification shows ONE added line, picked by its key (cart-notification-product-<key>).
            // Render it with the first key (header count, button, open), then put every added line in the slot.
            const keys = (response.items || []).map((item) => item.key);
            cart.renderContents(Object.assign({}, response, { key: keys[0] }));
            const html = response.sections && response.sections['cart-notification-product'];
            const slot = document.getElementById('cart-notification-product');
            if (html && slot && keys.length > 1) {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const rows = keys.map((key) => doc.querySelector('[id="cart-notification-product-' + key + '"]')).filter(Boolean);
              if (rows.length === keys.length) {
                // each row = photo + name/options; the cart's meal total (inside every row) is shown once, last
                const keep = ['.cart-notification-product__image', '.cart-notification-product__info'];
                const extra = [...rows[rows.length - 1].children].filter((el) => !keep.some((sel) => el.matches(sel)));
                slot.innerHTML = rows.map((row) => {
                  const copy = row.cloneNode(true);
                  [...copy.children].forEach((el) => {
                    if (!keep.some((sel) => el.matches(sel))) el.remove();
                  });
                  return copy.outerHTML;
                }).join('') + extra.map((el) => el.outerHTML).join('');
              }
            }
          } else {
            cart.renderContents(response);
          }
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        })
        .catch(() => this.showError(this.t.tError))
        .finally(() => {
          this.button.classList.remove('loading');
          this.update();
        });
    }
  }

  window.customElements.define('furppl-combo', FurpplCombo);

  // Filters. Shopify allows 50 blocks per section, so the menu spans sections: every card moves into the first menu grid
  // (one grid, no half row where a section ends; founder 10-25: "why the gap?"). The pills (Christmas, type) and
  // the filter column (founder 10-25: "we need the same filters on the left that the product pages have": Price,
  // Category, Color, in the collection pages' own markup) filter it together: AND across filters, OR inside one.
  // Deep links preset the pills or open on one combo.
  function initFilters() {
    const cards = [...document.querySelectorAll('furppl-combo[data-menu]')];
    if (!cards.length) return;
    const box = document.querySelector('.furppl-combos [data-filters]');
    const home = box ? box.closest('.furppl-combos') : cards[0].closest('.furppl-combos');
    const grid = home.querySelector('.furppl-combos__grid');
    if (!(window.Shopify && window.Shopify.designMode)) {
      const roots = new Set(cards.map((card) => card.closest('.furppl-combos')));
      cards.forEach((card) => {
        if (card.parentElement !== grid) grid.appendChild(card);
      });
      roots.forEach((root) => {
        if (root !== home) root.hidden = true;
      });
    }
    const t = home.dataset;
    const plain = formatter(t.moneyPlain || t.money);
    const state = { type: '', xmas: '', hue: '', min: null, max: null, cat: new Set(), color: new Set(), q: '' };
    // the sets search: every typed word in the set's name or one of its pieces' names; dog = paw (FURPPL 2026-10-31)
    const fold = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const synonyms = [['dog', 'dogs', 'paw', 'paws', 'perro', 'perros', 'huella', 'huellas', 'pata', 'patas']];
    const words = (card) => card._furpplWords || (card._furpplWords = fold([card.querySelector('.furppl-combo__name')]
      .concat([...card.querySelectorAll('a[href*="/products/"]')]).map((e) => (e ? e.textContent : '')).join(' ')));
    const matchQ = (card) => fold(state.q).split(/\s+/).filter(Boolean).every((w) => (synonyms.find((g) => g.includes(w)) || [w]).some((a) => words(card).includes(a)));
    let searchInput = null;
    const pills = box ? [...box.querySelectorAll('[data-f]')] : [];
    // a type or colour button that no set has stays hidden (10-26: the 197 sets are collar or harness sets, no leash)
    pills.forEach((pill) => {
      if (pill.dataset.f === 'type' || pill.dataset.f === 'hue') pill.hidden = !cards.some((card) => card.dataset[pill.dataset.f] === pill.dataset.v);
    });
    const count = box && box.querySelector('[data-count]');
    const countM = home.querySelector('[data-count-m]');
    const none = home.querySelector('[data-none]');
    // FURPPL 2026-10-31 (founder picked Marketing's note): after a search with no match, the line names the search
    const noneText = none && none.firstChild && none.firstChild.nodeType === 3 ? none.firstChild : null;
    const noneDefault = noneText ? noneText.textContent : '';
    const facets = home.querySelector('[data-facets]');
    const cents = (card) => Number(card.dataset.from) || 0;
    const colorsOf = (card) => (card.dataset.colors || '').split(',').filter(Boolean);
    const parse = (text) => Object.fromEntries((text || '').split(';').map((x) => x.split('=').map((y) => y.trim())).filter((x) => x[0] && x[1]));
    const colorNames = parse(t.colorLabels);
    const swatches = parse(t.colorSwatches);
    const catNames = { necklace: t.tCatNecklace, earrings: t.tCatEarrings, bracelet: t.tCatBracelet };
    const top = Math.ceil(Math.max.apply(null, cards.map(cents)) / 100);
    const minIn = facets && facets.querySelector('[data-price-min]');
    const maxIn = facets && facets.querySelector('[data-price-max]');
    const slider = facets && facets.querySelector('[data-slider]');

    const apply = (write) => {
      let shown = 0;
      cards.forEach((card) => {
        const c = cents(card);
        const ok = (!state.type || card.dataset.type === state.type) && (!state.xmas || card.dataset.xmas === '1')
          && (state.min === null || c >= Math.round(state.min * 100)) && (state.max === null || c <= Math.round(state.max * 100))
          && (!state.cat.size || state.cat.has(card.dataset.cat))
          && (!state.color.size || colorsOf(card).some((x) => state.color.has(x)))
          && (!state.hue || card.dataset.hue === state.hue)
          && (!state.q || matchQ(card));
        card.hidden = !ok;
        if (ok) shown += 1;
      });
      // "All" = no filter at all; every other pill is on while its value is the filter's
      const clear = !state.type && !state.xmas && !state.hue && state.min === null && state.max === null && !state.cat.size && !state.color.size && !state.q;
      pills.forEach((pill) => pill.setAttribute('aria-pressed', String(pill.dataset.f === 'all' ? clear : state[pill.dataset.f] === pill.dataset.v)));
      if (facets) {
        ['cat', 'color'].forEach((key) => {
          const badge = facets.querySelector('[data-facet="' + key + '"] [data-selected]');
          if (!badge) return;
          badge.textContent = state[key].size ? ' ' + state[key].size : '';
          badge.classList.toggle('hidden', !state[key].size);
        });
      }
      if (count) count.textContent = shown === 1 ? t.tCountOne : t.tCountMany.replace('[count]', String(shown));
      if (countM) countM.textContent = shown === 1 ? t.tCountOne : t.tCountMany.replace('[count]', String(shown));
      if (none) none.hidden = shown > 0;
      if (noneText) {
        const esNone = (document.documentElement.lang || '').toLowerCase().indexOf('es') === 0;
        noneText.textContent = state.q ? (esNone ? 'Ningún conjunto coincide con “' + state.q + '”. ' : 'No sets match “' + state.q + '”. ') : noneDefault;
      }
      if (!write) return;
      const tokens = [];
      if (state.type) tokens.push(state.type.replace('_', '-'));
      if (state.xmas) tokens.push('christmas');
      if (state.hue) tokens.push(state.hue);
      try {
        const url = new URL(window.location.href);
        if (tokens.length) url.searchParams.set('filter', tokens.join(','));
        else url.searchParams.delete('filter');
        url.searchParams.delete('combo');
        url.searchParams.delete('set');
        url.hash = '';
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) {
        /* the page works without the address update */
      }
    };

    // the filter column: each option from the cards, with its count said to screen readers, as on the collection pages
    if (facets) {
      const tally = (list) => list.reduce((map, key) => map.set(key, (map.get(key) || 0) + 1), new Map());
      const lists = { cat: tally(cards.map((card) => card.dataset.cat).filter(Boolean)), color: tally(cards.flatMap(colorsOf)) };
      ['cat', 'color'].forEach((key) => {
        const ul = facets.querySelector('[data-options="' + key + '"]');
        if (!ul) return;
        const order = key === 'cat' ? ['necklace', 'earrings', 'bracelet'] : Object.keys(colorNames);
        const rank = (value) => (order.indexOf(value) + 1) || 999;
        [...lists[key].keys()].sort((a, b) => rank(a) - rank(b)).forEach((value, i) => {
          const name = (key === 'cat' ? catNames[value] : colorNames[value]) || value;
          const id = 'FurpplCombos-' + key + '-' + (i + 1);
          const li = document.createElement('li');
          li.className = 'list-menu__item facets__item';
          li.innerHTML = key === 'cat'
            ? '<label class="facets__label facet-checkbox checkbox"><input type="checkbox"><span class="checkbox__checkmark"></span>'
              + '<span class="facet-checkbox__text" aria-hidden="true"><span class="facet-checkbox__text-label"></span></span><span class="visually-hidden"></span></label>'
            : '<div class="facets__label facet-checkbox swatch-square metafields-swatch"><div class="swatch-input-wrapper">'
              + '<input type="checkbox" class="swatch-input__input"><label class="swatch-color"><span class="swatch"></span></label></div>'
              + '<span class="facet-checkbox__text" aria-hidden="true"><span class="facet-checkbox__text-label"></span></span><span class="visually-hidden"></span></div>';
          const input = li.querySelector('input');
          input.id = id;
          input.value = value;
          const label = li.querySelector('label');
          label.htmlFor = id;
          if (key === 'color') {
            label.title = name;
            li.querySelector('.swatch').style.setProperty('--swatch--background', swatches[value] || '#cccccc');
          }
          li.querySelector('.facet-checkbox__text-label').textContent = name;
          li.querySelector('.visually-hidden').textContent = name + ' (' + lists[key].get(value) + ')';
          input.addEventListener('change', () => {
            if (input.checked) state[key].add(value);
            else state[key].delete(value);
            apply(true);
          });
          ul.append(li);
        });
      });
      // Price: the theme's slider settings (facets.js) and its From / To fields, on each combo's "from" price
      const maxLabel = facets.querySelector('[data-max-price]');
      if (maxLabel) maxLabel.textContent = t.tMaxPrice.replace('[price]', plain(top * 100));
      const readPrice = () => {
        const lo = parseFloat((minIn.value || '').replace(/[^\d.]/g, ''));
        const hi = parseFloat((maxIn.value || '').replace(/[^\d.]/g, ''));
        state.min = isNaN(lo) || lo <= 0 ? null : lo;
        state.max = isNaN(hi) || hi >= top ? null : hi;
      };
      if (minIn && maxIn) {
        maxIn.placeholder = String(top);
        [minIn, maxIn].forEach((input, i) => input.addEventListener('change', () => {
          readPrice();
          if (slider && slider.noUiSlider) slider.noUiSlider.set(i ? [null, state.max === null ? top : state.max] : [state.min === null ? 0 : state.min, null]);
          apply(true);
        }));
        if (slider && window.noUiSlider && top > 0) {
          window.noUiSlider.create(slider, {
            start: [0, top], connect: true, step: 1, range: { min: 0, max: top },
            handleAttributes: [{ 'aria-label': 'lower' }, { 'aria-label': 'upper' }],
          });
          let sliding = false;
          slider.noUiSlider.on('start', () => {
            sliding = true;
          });
          slider.noUiSlider.on('update', (values) => {
            if (!sliding) return;
            minIn.value = String(Math.round(Number(values[0])));
            maxIn.value = String(Math.round(Number(values[1])));
          });
          slider.noUiSlider.on('end', () => {
            sliding = false;
            readPrice();
            apply(true);
          });
        }
      }
      // phones: the column opens above the grid from its Filters button, as "Filters and sort" does on the collection pages
      const open = home.querySelector('[data-open-facets]');
      const setOpen = (on) => {
        home.classList.toggle('is-facets-open', on);
        if (open) open.setAttribute('aria-expanded', String(on));
      };
      if (open) open.addEventListener('click', () => setOpen(!home.classList.contains('is-facets-open')));
      // the collection pages' panel bar and footer (founder 10-25, "yes"): the close button and Apply close it
      home.querySelectorAll('[data-close-facets]').forEach((b) => b.addEventListener('click', () => {
        setOpen(false);
        if (open) open.focus();
      }));
    }

    const reset = () => {
      state.type = '';
      state.xmas = '';
      state.hue = '';
      state.min = null;
      state.max = null;
      state.cat.clear();
      state.color.clear();
      state.q = '';
      if (searchInput) {
        searchInput.value = '';
        searchInput.dispatchEvent(new Event('furppl-cleared'));
      }
      if (!facets) return;
      facets.querySelectorAll('[data-options] input').forEach((input) => {
        input.checked = false;
      });
      if (minIn) minIn.value = '';
      if (maxIn) maxIn.value = '';
      if (slider && slider.noUiSlider) slider.noUiSlider.set([0, top]);
    };
    // one type, Christmas; tapping an active pill turns it off, "All" clears everything (the column too)
    pills.forEach((pill) => pill.addEventListener('click', () => {
      const f = pill.dataset.f;
      if (f === 'all') reset();
      else state[f] = state[f] === pill.dataset.v ? '' : pill.dataset.v;
      apply(true);
    }));
    // Clear All in the phone panel: every filter off, as the "All" pill does
    const clearAll = home.querySelector('[data-clear-facets]');
    if (clearAll) clearAll.addEventListener('click', () => {
      reset();
      apply(true);
    });
    const showAll = home.querySelector('[data-show-all]');
    if (showAll) showAll.addEventListener('click', () => {
      reset();
      apply(true);
    });
    // FURPPL 2026-10-31 (founder: "you missed the page filter for ... her-and-her-dog"): search inside the sets, a filter like
    // the pills (AND with them, the same count and "no sets" message); every word must be in the set's name or one of its pieces'
    // names (accents and case ignored; dog = paw, as on the collection pages' search). sets_search_1031.py
    if (box && !home.querySelector('.furppl-sets-search')) {
      const es = (document.documentElement.lang || '').toLowerCase().indexOf('es') === 0;
      const heading = (document.querySelector('h1') || {}).textContent;
      const label = es ? 'Buscar en esta página' : 'Search ' + ((heading || '').trim() || 'sets');
      const wrap = document.createElement('div');
      wrap.className = 'furppl-sets-search';
      wrap.innerHTML = '<label class="visually-hidden" for="FurpplSetsSearch"></label>'
        + '<svg aria-hidden="true" focusable="false" viewBox="0 0 20 20" width="18" height="18"><circle cx="8.5" cy="8.5" r="6" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M13 13l5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>'
        + '<input id="FurpplSetsSearch" type="search" autocomplete="off" enterkeyhint="search">'
        + '<button type="button" hidden><svg aria-hidden="true" focusable="false" viewBox="0 0 20 20" width="14" height="14"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>';
      wrap.querySelector('label').textContent = label;
      const input = wrap.querySelector('input');
      const clearBtn = wrap.querySelector('button');
      input.placeholder = label;
      clearBtn.setAttribute('aria-label', es ? 'Borrar búsqueda' : 'Clear search');
      const style = document.createElement('style');
      style.textContent = '.furppl-sets-search{position:relative;max-width:440px;margin:0 0 14px}'
        + '.furppl-sets-search>svg{position:absolute;left:16px;top:50%;transform:translateY(-50%);color:rgb(72,41,34);pointer-events:none}'
        + '.furppl-sets-search input{width:100%;height:44px;padding:0 44px;border:1px solid rgb(247,206,215)!important;border-radius:22px;background:#fff;font-size:16px;color:inherit;box-shadow:none!important;outline:none;-webkit-appearance:none;appearance:none}'
        + '.furppl-sets-search input::-webkit-search-cancel-button{-webkit-appearance:none;display:none}'
        + '.furppl-sets-search button{position:absolute;right:6px;top:50%;transform:translateY(-50%);width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:50%;background:#F7F5F6;color:rgb(72,41,34);cursor:pointer;padding:0}'
        + '.furppl-sets-search button[hidden]{display:none}'
        + '@media screen and (max-width:1023px){.furppl-sets-search{max-width:none}}';
      document.head.appendChild(style);
      box.parentNode.insertBefore(wrap, box);
      let timer;
      const run = () => {
        state.q = input.value.trim();
        clearBtn.hidden = !input.value;
        apply(false);
      };
      input.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(run, 200);
      });
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          input.value = '';
          run();
        }
      });
      clearBtn.addEventListener('click', () => {
        input.value = '';
        run();
        input.focus();
      });
      searchInput = input;
    }
    const query = new URLSearchParams(window.location.search);
    const tokens = (query.get('filter') || '').toLowerCase().split(',').map((s) => s.trim()).filter(Boolean);
    const hues = pills.filter((p) => p.dataset.f === 'hue').map((p) => p.dataset.v);
    tokens.forEach((f) => {
      if (['collar', 'collar-leash', 'harness', 'harness-leash'].includes(f)) state.type = f.replace('-', '_');
      else if (f === 'christmas' || f === 'xmas') state.xmas = '1';
      else if (hues.includes(f)) state.hue = f;
      // the old budget links set the Price filter: under $100 = to 99.99, 100 to 200, over $200 = from 200.01
      else if (f === 'under-100') state.max = 99.99;
      else if (f === '100-200') {
        state.min = 100;
        state.max = 200;
      } else if (f === 'over-200') state.min = 200.01;
    });
    if (state.min !== null || state.max !== null) {
      if (minIn) minIn.value = state.min === null ? '' : String(state.min);
      if (maxIn) maxIn.value = state.max === null ? '' : String(state.max);
      if (slider && slider.noUiSlider) slider.noUiSlider.set([state.min === null ? 0 : state.min, state.max === null ? top : state.max]);
      const price = facets && facets.querySelector('[data-facet="price"]');
      if (price && !price.open) price.querySelector('summary').click();
    }
    // Sort (founder 10-25: "Can we add Featured"): the collection pages' sort box on the sets. Featured = the menu's own
    // order; price = each card's "from" price; A-Z = its name in the page's language; ties keep the menu's order.
    // ?sort_by= as on the collection pages. Not in the theme editor, where every card stays in its own section.
    // phones get a second box at the top of the filter panel (founder 10-25: "move Featured to the top selection of
    // filters"); the two stay in step
    const sorters = [...home.querySelectorAll('[data-sort]')];
    const sorter = sorters[0];
    if (sorter && !(window.Shopify && window.Shopify.designMode)) {
      cards.forEach((card, i) => {
        card.dataset.i = String(i);
      });
      const nameOf = (card) => ((card.querySelector('.furppl-combo__name') || {}).textContent || '').trim();
      const collator = new Intl.Collator(document.documentElement.lang || undefined, { sensitivity: 'base', numeric: true });
      const sortBy = (value, write) => {
        const by = {
          'price-ascending': (a, b) => cents(a) - cents(b),
          'price-descending': (a, b) => cents(b) - cents(a),
          'title-ascending': (a, b) => collator.compare(nameOf(a), nameOf(b)),
          'title-descending': (a, b) => collator.compare(nameOf(b), nameOf(a)),
        }[value];
        cards.slice().sort((a, b) => (by ? by(a, b) : 0) || Number(a.dataset.i) - Number(b.dataset.i)).forEach((card) => grid.appendChild(card));
        if (!write) return;
        try {
          const url = new URL(window.location.href);
          if (value && value !== 'manual') url.searchParams.set('sort_by', value);
          else url.searchParams.delete('sort_by');
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (e) {
          /* the page works without the address update */
        }
      };
      const asked = query.get('sort_by');
      if (asked && [...sorter.options].some((o) => o.value === asked)) {
        sorters.forEach((s) => {
          s.value = asked;
        });
      }
      if (sorter.value !== 'manual') sortBy(sorter.value, false);
      sorters.forEach((s) => s.addEventListener('change', () => {
        sorters.forEach((o) => {
          if (o !== s) o.value = s.value;
        });
        sortBy(s.value, true);
      }));
    }
    // one set: ?set=<slug> or #set-<slug> (Marketing's slugs, e.g. the-rockstars-necklace-collar), or the older
    // ?combo=N / #combo-N
    const slug = (query.get('set') || (window.location.hash.match(/^#set-([a-z0-9-]+)$/i) || [])[1] || '').toLowerCase();
    const want = (query.get('combo') || (window.location.hash.match(/^#combo-(\d+)$/) || [])[1] || '').replace(/\D/g, '');
    const target = (slug && cards.find((card) => card.dataset.slug === slug)) || (want ? document.getElementById('combo-' + want) : null);
    apply(false);
    if (target && target.hidden) {
      reset();
      apply(false);
    }
    if (target) {
      window.requestAnimationFrame(() => {
        target.scrollIntoView({ block: 'start' });
        target.classList.add('is-target');
        window.setTimeout(() => target.classList.remove('is-target'), 2600);
      });
    } else if (tokens.length && box) {
      window.requestAnimationFrame(() => box.scrollIntoView({ block: 'start' }));
    }
  }

  // FURPPL 2026-10-26 (197 sets): menu sections after the first are LAZY (sections/furppl-combos.liquid): the page holds an
  // empty holder and their sets come right away, at low priority, from the Section Rendering API, so no request renders more
  // than one section of sets (the 199-set page answered 500 live at 17:09Z). The filters, the sort and the deep links start
  // once EVERY set is in, so a filter always covers all of them; a tap on a pill before then waits and is replayed. A holder
  // that still fails after three tries is left out and the page works with the sets it has.
  function loadLazy() {
    const holders = [...document.querySelectorAll('[data-lazy-section]')];
    const one = (holder, tries) => fetch(window.location.pathname + '?section_id=' + encodeURIComponent(holder.dataset.lazySection),
      { credentials: 'same-origin', priority: 'low' })
      .then((response) => {
        if (!response.ok) throw new Error(String(response.status));
        return response.text();
      })
      .then((html) => {
        const root = new DOMParser().parseFromString(html, 'text/html').querySelector('.furppl-combos');
        if (!root || !root.querySelector('furppl-combo')) throw new Error('no sets');
        holder.replaceWith(document.importNode(root, true));
      })
      .catch(() => (tries > 1 ? new Promise((done) => window.setTimeout(done, 1500)).then(() => one(holder, tries - 1)) : null));
    return Promise.all(holders.map((holder) => one(holder, 3)));
  }

  // FURPPL 2026-10-26 (founder: "When I select the option, it redirects immediately"): the homepage sets row's pills filter
  // the row in place. The first tap fetches the sets page once (its page + its later sections) and keeps every set; a pill then
  // shows the first matching sets in the row's two rows, All Sets brings back the row's own, "View all (N)" and the phone
  // rows' View all tiles open the sets page with that filter. A tap with a modifier key still follows the link (new tab); a
  // failed fetch opens the filtered sets page.
  function initHomePills() {
    const home = document.querySelector('.furppl-combos--home');
    const pills = home ? [...home.querySelectorAll('.furppl-combos__homepills a.furppl-combos__pill')] : [];
    if (!pills.length) return;
    const grids = [...home.querySelectorAll('.furppl-combos__grid')];
    const own = grids.map((grid) => [...grid.querySelectorAll('furppl-combo')]);
    const tiles = grids.map((grid) => [...grid.querySelectorAll('.furppl-see-all__link')].map((a) => [a, a.getAttribute('href')]));
    const per = Math.max(1, own[0].length);
    const more = home.querySelector('[data-homemore]');
    const count = more && more.querySelector('[data-homemore-count]');
    const page = new URL(pills[0].href, window.location.href).pathname;
    let sets = null;
    const load = () => sets || (sets = fetch(page, { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error(String(response.status));
        return response.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const first = [...doc.querySelectorAll('furppl-combo[data-menu]')];
        const ids = [...doc.querySelectorAll('[data-lazy-section]')].map((holder) => holder.dataset.lazySection);
        return Promise.all(ids.map((id) => fetch(page + '?section_id=' + encodeURIComponent(id), { credentials: 'same-origin' })
          .then((response) => response.text())
          .then((text) => [...new DOMParser().parseFromString(text, 'text/html').querySelectorAll('furppl-combo[data-menu]')])))
          .then((rest) => first.concat(...rest));
      })
      .catch((error) => {
        sets = null;
        throw error;
      }));
    const matches = (card, f) => (f === 'christmas' ? card.dataset.xmas === '1'
      : f === 'collar' || f === 'harness' ? card.dataset.type === f : card.dataset.hue === f);
    const show = (cards) => grids.forEach((grid, i) => {
      grid.querySelectorAll('furppl-combo').forEach((card) => card.remove());
      const tile = grid.querySelector('.furppl-see-all');
      cards.slice(i * per, (i + 1) * per).forEach((card) => grid.insertBefore(card, tile));
      grid.hidden = !grid.querySelector('furppl-combo');
    });
    pills.forEach((pill) => pill.addEventListener('click', (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;
      event.preventDefault();
      pills.forEach((p) => p.classList.toggle('is-current', p === pill));
      const f = new URL(pill.href, window.location.href).searchParams.get('filter');
      if (!f) {
        show([].concat(...own));
        tiles.forEach((row) => row.forEach(([a, href]) => a.setAttribute('href', href)));
        if (more) more.hidden = true;
        return;
      }
      tiles.forEach((row) => row.forEach(([a]) => a.setAttribute('href', pill.getAttribute('href'))));
      home.classList.add('is-loading');
      load()
        .then((all) => {
          if (!pill.classList.contains('is-current')) return;
          const hit = all.filter((card) => matches(card, f));
          show(hit.slice(0, per * grids.length).map((card) => {
            const copy = document.importNode(card, true);
            copy.removeAttribute('id');
            copy.removeAttribute('data-menu');
            copy.hidden = false;
            return copy;
          }));
          if (more) {
            more.setAttribute('href', pill.getAttribute('href'));
            if (count) count.textContent = ' (' + hit.length + ')';
            more.hidden = false;
          }
        })
        .catch(() => {
          window.location.href = pill.href;
        })
        .finally(() => home.classList.remove('is-loading'));
    }));
  }

  function start() {
    if (!document.querySelector('[data-lazy-section]')) {
      initFilters();
      return;
    }
    const early = [];
    const hold = (event) => {
      const pill = event.target.closest && event.target.closest('.furppl-combos [data-f], .furppl-combos [data-show-all], .furppl-combos [data-clear-facets]');
      if (!pill) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      early.push(pill);
    };
    document.addEventListener('click', hold, true);
    loadLazy().then(() => {
      document.removeEventListener('click', hold, true);
      initFilters();
      early.forEach((pill) => pill.click());
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHomePills);
  else initHomePills();
})();
